import React from 'react';
import config from '../config/app.json';
import { errorlog } from '../helpers/ErrorLogService';

class BgVideoComponent extends React.Component { 

    
    constructor(props){
        super(props);
        this.appUrl = config['APPICONS'][config['APPICONS']['current']]
        this.mainDimensions = {width:'',  height:'', left:''};
        this.state={
            minThumbHeight : '',
            minThumbLeft : '',
            maxThumbHeight:'',
            maxThumbLeft : '',
            commonPopupLeft : '',
            minThumbWidth : '',
            innerWrapperLeft : '',
            innerWrapperWidth : '',
            videoDuration: '',
            muteValue:false,
            volume: 0,
            tempVolume: 0,
            videoThumbnailSeries : this.appUrl + '/images/loading/load-progress.gif',
            startThumbTime : '',
            endThumbTime : '',
            playVideo:false,
            indicatorPos: 0,
            effects : false,
            filterType : '',
            pastArr : '',
            filterEffects : false,
            filterCode : '32646400064 -10000',
            gifWidth : 0,
            inputEnd : 0,
            inputStart : 0,
            playStarted: false,
            playEnded: false,
            minisMoving: false,
            maxisMoving:false,
            isPlaying: false
        }
        this.onThumbMove = this.onThumbMove.bind(this);
        this.onMultipleChange = this.onMultipleChange.bind(this);
        this.addCss = this.addCss.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.setDummyThumbnail = this.setDummyThumbnail.bind(this);
        this.handleplayheadMove = this.handleplayheadMove.bind(this);
        this.handleplayheadClick = this.handleplayheadClick.bind(this);
        this.removeListeners = this.removeListeners.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.addEffects = this.addEffects.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
		this.assetUrl = config['ASSETS'][config['ASSETS']['current']];


        //THumbNail Details displaying..
        this.vid = ''; 
        this.thumbId = '';
        this.totalDur = ''; 
        this.timeScale = ''; 
        this.thumbnailIndex = '';
        this.vidTime = '';
        this.sources = [];
        this.cursorHeight = 0;
        this.loadImages = this.loadImages.bind(this);
        this.getThumbnail = this.getThumbnail.bind(this);
        this.loadedData = true;
        this.maxThumPosition = '';
        this.minThumPosition = '';
        this.effectsOutput = [];
        this.completeThumbnail = false;
        this.defaultThumbPosition = 0;
        this.applyVideoChanges = this.applyVideoChanges.bind(this);
        this.thumbs=[];
        this.container= {width: '800px', height: '530px'};
        this.videoWidth = 800;
        this.videoHeight = 450;
        this.volumeUI = [];

    }

    static defaultProps = {
		tintOpacity: 0.1,
		initIntensity: 50,
		initBright: 100,
		initContrast: 100,
		initHue: 0,
		initSaturate: 100,
		initTint: -1,
		initBlur: 0,
		initvignette: 0,
	}

    componentDidMount(){
        var firstDivision = document.getElementsByClassName('first-play-button')[0] ? document.getElementsByClassName('first-play-button')[0].offsetWidth : 0;
        var videTag = document.getElementById("video-in-popup");
        var firstTime = document.getElementsByClassName('cut-start-time')[0] ? document.getElementsByClassName('cut-start-time')[0].offsetWidth : 0; 
        this.defaultThumbPosition = firstDivision+firstTime;
        let objWidth = document.querySelector(".second-video-range").offsetWidth;
        this.generateThumbnails();
        if( this.props.isBGVideoSwapinLite && this.props.BgUndoData.videoEnd<=this.props.workspaceBG.get("videoDuration") ){
            let mincursorValue= parseFloat( (this.props.BgUndoData.videoStart ).toFixed(1));
            videTag.currentTime = mincursorValue;
            let maxcursorValue= parseFloat( (this.props.BgUndoData.videoEnd ).toFixed(1))
            let duration = this.props.BgUndoData.videoEnd - this.props.BgUndoData.videoStart;
            let mincursorX = parseFloat((this.props.BgUndoData.videoStart)/this.props.workspaceBG.get("videoDuration")*objWidth);
            let maxcursorX =  parseFloat((this.props.BgUndoData.videoEnd)/this.props.workspaceBG.get("videoDuration")*objWidth);
            this.setState({
                minCursorX: mincursorX,
                minCursorValue: mincursorValue,
                maxCursorX: maxcursorX,
                maxCursorValue:maxcursorValue ,
                totalWidth: objWidth,
                totalDuration: this.props.workspaceBG.get("videoDuration"),
                volume: parseInt(this.props.BgUndoData.volume)>=0?parseInt(this.props.BgUndoData.volume):100
            });
        }
        else {
            let mincursorValue= parseFloat( (this.props.workspaceBG.get("videoStart") ).toFixed(1));
            videTag.currentTime = mincursorValue;
            let maxcursorValue= parseFloat( (this.props.workspaceBG.get("videoEnd") ).toFixed(1))
            let duration = this.props.workspaceBG.get("videoEnd") - this.props.workspaceBG.get("videoStart");
            let mincursorX = parseFloat((this.props.workspaceBG.get("videoStart")/this.props.workspaceBG.get("videoDuration"))*objWidth);
            let maxcursorX =  parseFloat((this.props.workspaceBG.get("videoEnd")/this.props.workspaceBG.get("videoDuration"))*objWidth);
            this.setState({
                minCursorX: mincursorX,
                minCursorValue: mincursorValue,
                maxCursorX: maxcursorX,
                maxCursorValue:maxcursorValue ,
                totalWidth: objWidth,
                totalDuration: this.props.workspaceBG.get("videoDuration"),
                volume: parseInt(this.props.workspaceBG.get("volume"))>=0?parseInt(this.props.workspaceBG.get("volume")):100
            });
        }
        let nextBtn = document.querySelector('.next_step');
        if(nextBtn){
            this.props.nextBtnClicked(true);
            nextBtn.classList.remove('disable');
            nextBtn.click();
        }

    }
    componentWillReceiveProps(nextProps){
        if(nextProps.workspaceBG.get("type")==="UPVIDEO" || nextProps.workspaceBG.get("type")==="STOCKVID" ){
        if(nextProps.workspaceBG.get('src')!==this.props.workspaceBG.get("src")){

            this.props=nextProps;
            let objWidth = document.querySelector(".second-video-range").offsetWidth;
            this.generateThumbnails();
            let mincursorValue= parseFloat( (this.props.workspaceBG.get("videoStart") ).toFixed(1));
            let maxcursorValue= parseFloat( (this.props.workspaceBG.get("videoEnd") ).toFixed(1))
            let duration = this.props.workspaceBG.get("videoEnd") - this.props.workspaceBG.get("videoStart");
            let mincursorX = parseFloat((this.props.workspaceBG.get("videoStart")/this.props.workspaceBG.get("videoDuration"))*objWidth);
            let maxcursorX =  parseFloat((this.props.workspaceBG.get("videoEnd")/this.props.workspaceBG.get("videoDuration"))*objWidth);
            this.setState({
                minCursorX: mincursorX,
                minCursorValue: mincursorValue,
                maxCursorX: maxcursorX,
                maxCursorValue:maxcursorValue ,
                totalWidth: objWidth,
                totalDuration: this.props.workspaceBG.get("videoDuration"),
                volume: parseInt(this.props.workspaceBG.get("volume"))>=0?parseInt(this.props.workspaceBG.get("volume")):100
            });
        }
    }
    }
 
    componentWillMount(){
        window.addEventListener('mouseup', this.removeListeners, false);
        this._addListeners();
        this.props.setWorkspaceTextFocus(true);
    }


    
    componentDidUpdate(){
        let elements = document.getElementsByClassName('filterEdit-icon');
		if(elements && elements.length > 0)
		{
			for(let i=0; i < elements.length; i++){
				elements[i].style.display = "none";
            }
            if(this.state.filterType !== "")
			    document.getElementById(this.state.filterType.toLowerCase() + "-filterEdit").style.display = "flex";
        }
    }

    removeListeners(){
        window.removeEventListener('mousemove', this.handleplayheadMove, false);
    }

    componentWillUnmount(){
        window.removeEventListener('mouseup', this.removeListeners, false);
        let videoTag = document.getElementById('video-in-popup');
        videoTag.removeEventListener("timeupdate", this.getCurTime, false);
        this._removeListeners();
    }


    secondsToHms(d) {
        d = Number(d);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);
    
        var mDisplay = m > 0 ? m + (m === 1 ? "" : "") : "";
        var sDisplay = s > 0 ? s + (s === 1 ? "" : "") : "";
        if(sDisplay !== null && sDisplay.length >=1){
            sDisplay =  sDisplay.length > 1 ? sDisplay : '0'+sDisplay;
        }else{
            sDisplay = '00';
        }
        if(mDisplay !== null && mDisplay !== ""){
            mDisplay =  mDisplay.length > 1 ? mDisplay : '0'+mDisplay;
        }else{
            mDisplay = '00';
        }
        return mDisplay+':'+sDisplay; 
    }

    getCurTime =  () => {
        let videoTag = document.getElementById('video-in-popup');
        var videoStart = this.state.minCursorValue, videoEnd = this.state.maxCursorValue;
        if (videoTag.currentTime >= videoEnd || videoTag.currentTime >= videoTag.duration) {
          if (this.playPromise !== undefined) {
            this.playPromise.then(_ => {
                videoTag.pause();
                this.playPromise = undefined;
            })
            .catch(error => {
                errorlog("Popup video is paused before play start ", error, "BgVideoComponent-getCurTime");
            });
          }
          videoTag.currentTime = videoStart;
          let mincursorX = parseFloat((this.videoStarts/this.props.workspaceBG.get("videoDuration"))*this.state.totalWidth);
          videoTag.removeEventListener("timeupdate", this.getCurTime, false);
          this.setState({
            playVideo: false,
            isPlaying: false,
            playCursorX: 0
            })  
        }
        else{
            let mincursorX = parseFloat(( videoTag.currentTime/this.state.totalDuration)*this.state.totalWidth);
            this.setState({isPlaying: true, playCursorX: mincursorX-this.state.minCursorX})
            videoTag.volume = this.state.volume/100;
        }
    }

    runVideo(){
        try {
        let videoTag = document.getElementById('video-in-popup');
        videoTag.addEventListener("timeupdate", this.getCurTime, false);
        videoTag.currentTime = this.state.minCursorValue;
        if(!this.state.playVideo){
            this.videoStarts = Number(Math.round(videoTag.currentTime+"e1")+"e-1");
             videoTag.volume = this.state.volume/100;
            this.playPromise = videoTag.play();
        }else{
            videoTag.pause();
            this.playPromise = undefined;
            videoTag.removeEventListener("timeupdate", this.getCurTime, false);
        }

        this.setState({
            playVideo: !this.state.playVideo,
            isPlaying: !this.state.playVideo,
            playCursorX: 0
        })  
    }catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "BgVideoComponent-runVideo");
    }             
    }

    enableMute(event){
        try {
        var videoTag = document.getElementById('video-in-popup');
        videoTag.muted = !this.state.muteValue ;
        this.setState({
            muteValue : videoTag.muted,
            volume: videoTag.muted?0:100
        });
    } catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "BgVideoComponent-enableMute");
    }
    }

    setDummyThumbnail(){
        var video =  document.getElementById('video-in-popup');
        var source = this.assetUrl+"animaker/videothumbs/newimage.png";
        var thumbStrip=this.props.workspaceBG.get('src');
        if (this.props.workspaceBG.get('type') === "UPVIDEO"){
          let thumbSrc;
          if(this.props.workspaceBG.get('src').includes("proxy1"))
            thumbSrc =thumbStrip.replace('proxy1', 'thumbstrip');
          else{
            thumbSrc = thumbStrip.split('video/').join('video/thumbstrip/');
          }
          source = config['UPLOADS'][config['UPLOADS']['workspace_UPVIDEO']]+ thumbSrc.split(".")[0] + ".png"
          if(this.props.workspaceBG.get('isBlob')){
            source = this.props.workspaceBG.get('thumbnail');
          }
        }
        else if(this.props.workspaceBG.get('type')==="STOCKVID"){
            source = config['VIDEO']["thumbStrip"]+thumbStrip.split(".")[0]+".png";
        }


        let posterImg = new Image();
        posterImg.src =  source;
        posterImg.onload = function() {
            video.onloadedmetadata = function() {
                var totalWidth = document.getElementById('duration-in-width-video').offsetWidth;
                this.timeScale = totalWidth / video.duration;
                this.thumbWidth = (video.videoWidth/video.videoHeight)*this.cursorHeight;
                var frameCount = Math.ceil(video.duration*this.timeScale/(this.thumbWidth)) + 2;
                var canvas = document.createElement("canvas");
                canvas.width = this.thumbWidth;
                canvas.height = this.cursorHeight;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(posterImg, 0, 0, this.thumbWidth, this.cursorHeight);

                var dataURL = canvas.toDataURL();
                var imgSrcArr = new Array(frameCount);
                imgSrcArr.fill(dataURL);
                this.loadImages(imgSrcArr,function(images)
                {
                    var canvas = document.createElement('canvas');
                    var context = canvas.getContext('2d');
                    canvas.width = video.duration*this.timeScale;
                    canvas.height = this.cursorHeight;
                    var xpos = 0;
                    if(Object.keys(images).indexOf(NaN) >= 0) return;
                    
                    for(var x in images ) {
                        if(x)
                        {
                            context.drawImage(images[x], xpos, 0, this.thumbWidth, this.cursorHeight);
                            xpos += this.thumbWidth;
                        }
                    }
                    if(Object.keys(images).length < frameCount)
                    {
                        for(var cnt=0; cnt < frameCount-Object.keys(images).length; cnt++)
                        {
                            context.drawImage(images[x], xpos, 0, this.thumbWidth, this.cursorHeight);
                            xpos += this.thumbWidth;
                        }
                    }
                    this.loadedData = true;
                    var endThumbTime = this.props.workspaceBG.get('videoEnd');

                    if(endThumbTime > video.duration) endThumbTime = video.duration;
                    if(!this.completeThumbnail){
                        this.setState({ 
                            videoThumbnailSeries : canvas.toDataURL(),
                            videoDuration :  video.duration,
                            startThumbTime: this.props.workspaceBG.get('videoStart'),
                            endThumbTime : endThumbTime,
                            inputStart : this.props.workspaceBG.get('videoStart'),
                            inputEnd : endThumbTime
                        },() => {
                            this.addCss();
                        });
                    }
                }.bind(this))
            }.bind(this)
        }.bind(this)
    }

    getThumbnail(){
        this.vidTime = 0.001; this.sources = [];
        var video =  document.createElement('video');
        var source = this.assetUrl+"animaker/videothumbs/newimage.png";
        var thumbStrip=this.props.workspaceBG.get('src');
        var configBasePath = this.props.workspaceBG.get('src');
        if (this.props.workspaceBG.get('type') === "UPVIDEO"){
            let thumbSrc;
            if(this.props.workspaceBG.get('src').includes("proxy1"))
              thumbSrc =thumbStrip.replace('proxy1', 'thumbstrip');
            else{
              thumbSrc = thumbStrip.split('video/').join('video/thumbstrip/');
            }
            configBasePath = config['UPLOADS'][config['UPLOADS']['workspace_UPVIDEO']]+ thumbSrc.split(".")[0] + ".png";
            if(this.props.workspaceBG.get('isBlob')){
                configBasePath = this.props.workspaceBG.get('thumbnail');
            }
          }
          else if(this.props.workspaceBG.get('type')==="STOCKVID"){
              configBasePath = config['VIDEO']["thumbStrip"]+thumbStrip.split(".")[0]+".png";
          }


        video.src = configBasePath;
        video.id = "video-in-thumbnail";
        video.preload = "auto";
        this.vid = video; 
        this.thumbId = 'video-in-popup';
        video.currentTime = this.vidTime;
         video.onloadedmetadata = function() {
            this.loadedData = true;
            var pixelForOnesecond = (this.innerWrapperWidthMain)/video.duration, endThumbTime = this.props.workspaceBG.get('videoEnd');
            if(endThumbTime > video.duration) endThumbTime = video.duration;
            
            this.setState({ 
                videoDuration :  video.duration,
                startThumbTime: this.props.workspaceBG.get('videoStart'),
                endThumbTime : endThumbTime,
                inputStart : this.props.workspaceBG.get('videoStart'),
                inputEnd : endThumbTime
            },() => {
                this.addCss();
            });
             this.totalDur = video.duration; this.timeScale = pixelForOnesecond; this.thumbnailIndex = 1;
            video.addEventListener('seeked', this.videoSeek, false);
        }.bind(this);
       
    }

    generateThumbnail(i,video,thumbWidth,type){
        var canvas = document.createElement("canvas");
        canvas.width = thumbWidth;
        canvas.height = this.cursorHeight;
        
        var ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, thumbWidth, this.cursorHeight);
        let isEmpty = this.isCanvasTransparent(canvas,thumbWidth,this.cursorHeight);
        if(isEmpty)
        {
          video.currentTime = i+0.1;
          this.vidTime = i+0.1;
        }
        var dataURL = canvas.toDataURL();
        if(type !== 'temp' && !isEmpty)
          this.sources[i] = dataURL;

      }
      isCanvasTransparent = (canvas,width,height) => {
        var ctx = canvas.getContext("2d");
        if(width > 0 && height > 0)
        {
          var imageData = ctx.getImageData(0, 0, width,height);
          for (var i = 0; i < imageData.data.length; i += 4)
          {
            if (imageData.data[i + 3] !== 0) 
              return false;
          }
          return true;
        }
      }

    videoSeek = () => {
        this.thumbWidth = (this.vid.videoWidth/this.vid.videoHeight)*this.cursorHeight;
        var frameCount = Math.ceil(this.totalDur*this.timeScale/(this.thumbWidth)) + 2;
        var seekVal = this.totalDur/frameCount, checkVal = this.totalDur;
        this.generateThumbnail(this.vidTime,this.vid,this.thumbWidth);
        this.vidTime += seekVal;
       
        if (this.vidTime <= checkVal)
          this.vid.currentTime = this.vidTime;
        else
        {
        
          this.loadImages(this.sources,function(images)
          {
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            canvas.width = this.totalDur*this.timeScale;
            canvas.height = this.cursorHeight;
            var xpos = 0, state = {};
            if(Object.keys(images).indexOf(NaN) >= 0) return;
            
            for(var x in images ) {
              if(x)
              {
                context.drawImage(images[x], xpos, 0, this.thumbWidth, this.cursorHeight);
                xpos += this.thumbWidth;
              }
            }
            if(Object.keys(images).length < frameCount)
            {
              for(var cnt=0; cnt < frameCount-Object.keys(images).length; cnt++)
              {
                context.drawImage(images[x], xpos, 0, this.thumbWidth, this.cursorHeight);
                xpos += this.thumbWidth;
              }
            }
            this.loadedData = true;
            this.completeThumbnail = true;
            state['videoThumbnailSeries'] = canvas.toDataURL();
            this.setState(state, () => {
                this.vid.removeEventListener('seeked', this.videoSeek, false);
            })
          }.bind(this))
        }
    }

    loadImages = (sources, callback) => {
        var images = {}, numImages = Object.keys(sources).length;
        this.loadedImages = 0;
        
        for(var src in sources) {
          images[src] = new Image();
          images[src].onload = () => {
              this.arrangeImage(numImages,images,callback)
          }
          images[src].src = sources[src];
        }
    }
    arrangeImage = (numImages,images,callback) => {
        if(++this.loadedImages >= numImages)
        {
          callback(images);
        }
    }
    timelineReducer=(value)=> {
        let updateDetails = [], duration = parseFloat(value);
        let thumbArr = ['enterStart','enterEnd','exitStart','exitEnd','numStart','numEnd'], thumbValues = [];
        this.props.workspaceItems.entrySeq().forEach(([key, value]) => {
            thumbValues = [value.get('enterStart'),value.get('enterEnd'),value.get('exitStart'),value.get('exitEnd'),value.get('numStart'),value.get('numEnd')];
            for(let i=0; i < thumbArr.length; i++)
            {
                if(parseFloat(thumbValues[i]) >= duration)
                {
               
                if(thumbArr[i] === "enterStart")
                {
                    updateDetails.push({name: thumbArr[i],value: (duration-1)<0?0:(duration-1),id: key});
                    updateDetails.push({name: 'enterEffectName',value: 'no_Effect',id: key});
                    updateDetails.push({name: 'enterEnd',value: 0,id: key});
                }
                else if(thumbArr[i] === "numStart")
                    updateDetails.push({name: thumbArr[i],value: duration-0.1,id: key});
                else if(parseFloat(thumbValues[i]) > duration)
                    updateDetails.push({name: thumbArr[i],value: duration,id: key});
                }
            }
        })
       

        if(this.props.workspaceBG.get('src') !== '')
        {
            let duration = parseFloat(value);
            if(this.props.workspaceBG.get('exitEnd') > duration){
                updateDetails.push({name: 'bgEnd', value: duration});
            }
            if(this.props.workspaceBG.get('enterStart') > duration - 1)
                updateDetails.push({name: 'bgStart', value: duration-1});
        }
        return updateDetails;
    }
    addCss(){
        let thumbNailBackground = document.getElementById('videoSLiderDiv');
        let widthPerSecond = thumbNailBackground.offsetWidth/this.state.videoDuration;
        thumbNailBackground.style.boxShadow = `inset ${Math.round((this.state.startThumbTime*widthPerSecond)+2)}px 0px 0px 0px #ffffffe0, inset ${Math.round(this.state.endThumbTime*widthPerSecond-thumbNailBackground.offsetWidth)}px 0px 0px 0px #ffffffe0`;
   }
getWidthandHeight=(w,h)=>{
    let style={};
    let bgWidth = this.props.projectWidth * w;
    let bgHeight = this.props.projectHeight * h;
    let angle = 0;
    if(this.props.workspaceBG.get("angle") !== undefined)
        angle = this.props.workspaceBG.get("angle");
    style.transform = "rotatez("+ angle +"deg)";
    if(bgWidth > bgHeight) { 
        style.width = this.videoWidth+'px';
        style.height = ((this.videoWidth/bgWidth ) * bgHeight)+"px"
        return style
    }
    else if(bgWidth < bgHeight || bgWidth === bgHeight ){
        style.height = this.videoHeight+'px';
        style.width = ((this.videoHeight/bgHeight) * bgWidth)+"px"
        return style;
    }

}
applyVolume = (e)=>{
    try {
    if(this.state.volume!==e.target.value){
        if(parseInt(e.target.value)===0){
            this.setState({volume: 0, tempVolume: this.state.volume, muteValue: true});
        }
        else{
            this.setState({volume: parseInt(e.target.value), tempVolume: parseInt(e.target.value), muteValue: false });
        }
    }
}catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "BgVideoComponent-applyVolume");
}

}
saveVolume = (e)=>{

    this.props.changeVideoVolume({selectedScene:this.props.selectedScene,value:parseInt(e.target.value, 10)},this.props.socket)

}
    handleApply(){
        let duration = Number(Math.round((this.state.maxCursorValue -this.state.minCursorValue)+"e1" )+"e-1");
        var objectData = this.timelineReducer(duration);
        let timelineData = [{ name: "bgEnd", value: duration , key: "playHeadValue" }, { name: "videoStart", value: this.state.minCursorValue, key: "playHeadValue" },{ name: "videoEnd", value: this.state.maxCursorValue < this.props.workspaceBG.get("videoDuration") ? this.state.maxCursorValue : this.props.workspaceBG.get("videoDuration"), key: "playHeadValue" }, { name: "duration", value: duration, key: "playHeadValue"} ];
        timelineData = timelineData.concat(objectData);
        this.props.onItemDrag(this.props.socket, "workspaceItems", timelineData, "", this.props.selectedItems.toJS(), this.props.selectedScene);

    
                
        
        this.props.cancelPopup();
        let nextBtn = document.querySelector('.next_step');
        if(nextBtn){
            this.props.nextBtnClicked(true);
            nextBtn.classList.remove('disable');
            nextBtn.click();
        }
    }

    applyVideoChanges(){
        this.handleApply();
    }

    handleCancel(){
        try {
        this.props.openCommonPopup('',false);
        } catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "BgVideoComponent- handleCancel");
        }
    }

    onThumbMove(name,value,id, type) {
        var thumbNailBackground = document.getElementById('videoSLiderDiv');
        let widthPerSecond = thumbNailBackground.offsetWidth/this.state.videoDuration;
         if(type === 'min'){
             this.minThumPosition = value;
             this.setState({indicatorPos: this.defaultThumbPosition + value + 10});
             if((value !== undefined || value !== null || value !== '') && (this.maxThumPosition === null || this.maxThumPosition === '')) this.maxThumPosition = this.state.endThumbTime*widthPerSecond;
             thumbNailBackground.style.boxShadow = `inset ${Math.round(value+2)}px 0px 0px 0px #ffffffe0, inset ${Math.round(this.maxThumPosition-thumbNailBackground.offsetWidth)}px 0px 0px 0px #ffffffe0`;
         }else if(type === 'max'){
             this.maxThumPosition = value;
             if(this.minThumPosition !== undefined || this.minThumPosition !== null || this.minThumPosition !== '') this.minThumPosition = this.state.startThumbTime*widthPerSecond;
             thumbNailBackground.style.boxShadow = `inset ${Math.round(this.minThumPosition)}px 0px 0px 0px #ffffffe0, inset ${Math.round(this.maxThumPosition-thumbNailBackground.offsetWidth)}px 0px 0px 0px #ffffffe0`;
         }else if(type === 'updateStore'){
             let startTime = this.state.startThumbTime;
             let endTime = this.state.endThumbTime;
             if(name === 'enterStart')
             {
                 startTime  =  value;
                 let videoTag = document.getElementById('video-in-popup');
                 videoTag.currentTime = value;
             }
             else if(name === 'exitEnd')
                 endTime = value;

             this.setState({
                 startThumbTime  :   startTime,
                 endThumbTime    :   endTime,
                 inputStart      :   startTime,
                 inputEnd        :   endTime
             });
         }
         
     }


    onMultipleChange(name, values){
        let videoTag = document.getElementById('video-in-popup');
        videoTag.currentTime = this.state.startThumbTime;

        this.setState({
            endThumbTime    :   values[0].name === 'exitEnd' ? values[0].value : this.state.endThumbTime,
            startThumbTime  :   values[1].name === 'enterStart' ? values[1].value : this.state.startThumbTime,
            inputEnd    :   values[0].name === 'exitEnd' ? values[0].value : this.state.endThumbTime,
            inputStart  :   values[1].name === 'enterStart' ? values[1].value : this.state.startThumbTime
        })
    }

    onInputChange(position, e,type){
        var startTime = this.state.startThumbTime;
        var endTime = this.state.endThumbTime;
        if(type === "blur")
            this.props.setWorkspaceTextFocus(false);
        if(position === 'start'){
            if(type === "blur" && (Number(e.target.value) > Number(this.state.endThumbTime) || Math.abs(Number(e.target.value) - Number(this.state.endThumbTime)) > this.props.sceneDuration)){
                alert("Enter a valid start time.");
                startTime = this.state.startThumbTime;
            }else
                startTime = e.target.value;
        }
        if(position === 'end'){
            if(type === "blur" && (Number(e.target.value) < Number(this.state.startThumbTime) || Math.abs(Number(e.target.value) - Number(this.state.startThumbTime)) > this.props.sceneDuration)){
                alert("Enter a valid end time.");
                endTime = this.state.endThumbTime;
            }else
                endTime = e.target.value;
        }
        if(type === "blur"){
            var thumbNailBackground = document.getElementById('videoSLiderDiv');
            let widthPerSecond = thumbNailBackground.offsetWidth/this.state.videoDuration;
            thumbNailBackground.style.boxShadow = `inset ${Math.round((startTime*widthPerSecond)+4)}px 0px 0px 0px #ffffffe0, inset ${Math.round((endTime*widthPerSecond)-thumbNailBackground.offsetWidth)}px 0px 0px 0px #ffffffe0`;
            this.setState({
                startThumbTime:startTime,
                endThumbTime:endTime,
                inputStart:startTime,
                inputEnd:endTime
            })
        }
        else{
            this.setState({
                inputStart:startTime,
                inputEnd:endTime
            })
        }
    }
    secToMin =(sec) =>{
        let decimal =""
        if(Math.abs(parseFloat(sec) - Math.floor(parseFloat(sec)))){
          decimal = "."+Math.abs(parseFloat(sec) - Math.floor(parseFloat(sec))).toFixed(1).split(".")[1]
        }
        sec = Math.floor(sec)
        let rem = sec % 60;
        let quo = Math.round((sec - rem) / 60)
        let len = String(quo).length
        return `${("0" + quo).slice(-(len <= 1 ? 2 : len))}:${("0" + rem+decimal).slice(decimal?-4:-2)}`;
      }
    _addListeners() {
        window.addEventListener('mouseup', this.handleMouseUp, false);
      };
    
      _removeListeners() {
        window.removeEventListener('mouseup', this.handleMouseUp, false);
      }
handleMousedown = (e, cursor)=>{
    try {
    e.preventDefault();
    let secondVideo = document.querySelector(".second-video-range").getBoundingClientRect().left;
    let translateValue= e.clientX - secondVideo;
    if(cursor==="range")
    {
        let midShadow = document.querySelector("#mid-shadow");
        this.midWidth=midShadow.offsetWidth;
        this.setState({activeCursor: "range",initialrangeCursorX: e.clientX, minxD: this.state.minCursorX, maxxD: this.state.maxCursorX});
    }
    if(cursor==="min")
        this.setState({activeCursor: cursor,initialminCursorX:translateValue, minisMoving: true});
    if(cursor==="max")
        this.setState({activeCursor: cursor,initialmaxCursorX:translateValue, maxisMoving: true});

    window.addEventListener('mousemove', this.handleMouseMove, true);
} catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "BgVideoComponent-handleMousedown");
}
}
handleMouseMove= (e)=>{
    try {
    e.preventDefault();
    let secondLeft =document.querySelector(".second-video-range").getBoundingClientRect().left;
    let translateValue= e.clientX - secondLeft;

   
    let midWidth=document.querySelector("#mid-shadow").offsetWidth
    let videoElem = document.getElementById("video-in-popup");
   if(this.state.activeCursor==="range")
            translateValue = e.clientX;
    let tmaxmidValue =translateValue-this.midWidth;
    
    if(translateValue<this.state.initialrangeCursorX  && this.state.activeCursor==="range"  ){
        let negativeDeviation = this.state.initialrangeCursorX -translateValue;
        let midValue =  this.state.minxD-negativeDeviation;
        let maxMidValue=this.state.maxxD-negativeDeviation;
        if(midValue>=0){
        let cursorValue= parseFloat( ((midValue/this.state.totalWidth) * this.state.totalDuration ).toFixed(1));
        videoElem.currentTime=cursorValue;
        let maxcursorValue= parseFloat( ((maxMidValue/this.state.totalWidth) * this.state.totalDuration ).toFixed(1));
        this.setState({minCursorX :midValue, minCursorValue:cursorValue, maxCursorX: maxMidValue, maxCursorValue: maxcursorValue   });
        }
        else{
            let   maxcursorValue= parseFloat( (((this.midWidth+7)/this.state.totalWidth) * this.state.totalDuration ).toFixed(1));
            this.setState({minCursorX :0, minCursorValue:0, maxCursorX: this.midWidth+7, maxCursorValue: maxcursorValue });
        }
       
    }
    if(translateValue>this.state.initialrangeCursorX  && this.state.activeCursor==="range" ){
        let positiveDeviation = translateValue-this.state.initialrangeCursorX ;
        let midValue =  this.state.minxD+positiveDeviation;
        let maxMidValue=this.state.maxxD+positiveDeviation;
        if(maxMidValue<=this.state.totalWidth){
        let cursorValue= parseFloat( ((midValue/this.state.totalWidth) * this.state.totalDuration ).toFixed(1));
        videoElem.currentTime=cursorValue;
        let maxcursorValue= parseFloat( ((maxMidValue/this.state.totalWidth) * this.state.totalDuration ).toFixed(1));
        this.setState({minCursorX :midValue, minCursorValue:cursorValue, maxCursorX: maxMidValue, maxCursorValue: maxcursorValue   });
        }
        else{
            let maxCursorX = this.state.totalWidth ;
            let maxCursorValue  = parseFloat( ((maxCursorX/this.state.totalWidth) * this.state.totalDuration ).toFixed(1));
            let minCursorX = maxCursorX-this.midWidth-7;
            let minCursorValue =parseFloat( ((minCursorX/this.state.totalWidth) * this.state.totalDuration ).toFixed(1));
            this.setState({minCursorX :minCursorX, minCursorValue:minCursorValue, maxCursorX: maxCursorX, maxCursorValue: maxCursorValue   });
        }
        

    }

    if(translateValue!==this.state.initialminCursorX && this.state.activeCursor==="min"  && (translateValue+7)<this.state.maxCursorX ){
        if(translateValue<=0) {
            translateValue=0;
        }
        if(translateValue>=this.state.totalWidth){
            translateValue=this.state.maxCursorX-7;
        }
        
            let cursorValue= parseFloat( ((translateValue/this.state.totalWidth) * this.state.totalDuration ).toFixed(1));
            videoElem.currentTime=cursorValue;
            this.setState({minCursorX :translateValue, minCursorValue:cursorValue    });   
    }
       
    if(translateValue!==this.state.initialmaxCursorX && this.state.activeCursor==="max" && (translateValue-7)>this.state.minCursorX ){
        if(translateValue>=this.state.totalWidth){
            translateValue=this.state.totalWidth;
        }
        if(translateValue<0){
            translateValue= this.state.minCursorX+7;
        }
        let cursorValue= parseFloat(((translateValue/this.state.totalWidth) * this.state.totalDuration).toFixed(1));
        videoElem.currentTime=cursorValue;
        this.setState({maxCursorX :translateValue, maxCursorValue: cursorValue  });
    }
}catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "BgVideoComponent-handleMouseMove");
}
}
handleMouseUp= (e)=>{
    try {
    this.setState({minisMoving: false, maxisMoving: false})
    window.removeEventListener('mousemove', this.handleMouseMove, true);
    } catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "BgVideoComponent-handleMouseUp");
    }
}
    componentWillUpdate(nextProps, nextState){
        if(nextProps.changedDimensions !== this.props.changedDimensions){
            var totalWidth = document.getElementById('duration-in-width-video').offsetWidth;
            this.timeScale = totalWidth / this.state.videoDuration;
            this.setState({indicatorPos: nextState.startThumbTime*this.timeScale+this.defaultThumbPosition});
            var thumbNailBackground = document.getElementById('videoSLiderDiv');
            let widthPerSecond = thumbNailBackground.offsetWidth/nextState.videoDuration;
            thumbNailBackground.style.boxShadow = `inset ${Math.round(nextState.startThumbTime*widthPerSecond)}px 0px 0px 0px #ffffffe0, inset ${Math.round((nextState.endThumbTime*widthPerSecond)-thumbNailBackground.offsetWidth)}px 0px 0px 0px #ffffffe0`;
         }
        this.effectsOutput = [];
        var minTransform={ transform: `translate3d(${this.state[`minCursorX`]}px,0,10px)`};
        var maxTransform={ transform: `translate3d(${this.state[`maxCursorX`]}px,0,10px)`};
        var minshadowWidth ={ width: `${this.state[`minCursorX`]}px`, transform: `translate3d(0,0,10px)` };
        var maxshadowWidth= { width:  nextState[`totalWidth`]-nextState[`maxCursorX`]-7+"px", transform: `translate3d(${nextState[`maxCursorX`]+7}px,0,10px)` }
        var midShadow={width:  nextState[`maxCursorX`]-nextState[`minCursorX`]-7+"px", transform: `translate3d(${nextState[`minCursorX`]+7}px,0,10px)` }
    this.thumbs.length=0;
    if(nextState[`minCursorX`]!==this.state.minCursorX){
        minTransform= { transform: `translate3d(${nextState[`minCursorX`]}px,0,10px)`};
        minshadowWidth ={ width: `${nextState[`minCursorX`]}px`, transform: `translate3d(0,0,10px)` };
        midShadow={width:  nextState[`maxCursorX`]-nextState[`minCursorX`]-7+"px", transform: `translate3d(${nextState[`minCursorX`]+7}px,0,10px)` }
    }
    if (nextState[`maxCursorX`]!==this.state.maxCursorX){
         maxTransform = { transform: `translate3d(${nextState[`maxCursorX`]-1}px,0,10px)` };
         maxshadowWidth=nextState[`maxCursorX`]>=nextState.totalWidth?{  width: 0+"px", transform: `translate3d(${nextState[`maxCursorX`]+7}px,0,10px)` }:{  width: nextState[`totalWidth`]-nextState[`maxCursorX`]-7+"px", transform: `translate3d(${nextState[`maxCursorX`]+7}px,0,10px)` }
         midShadow={width:  nextState[`maxCursorX`]-nextState[`minCursorX`]-7+"px", transform: `translate3d(${nextState[`minCursorX`]+7}px,0,10px)` }
        }
      this.thumbs.push(
          <React.Fragment>
              <div id="min-shadow" style={minshadowWidth} >  {nextState.minisMoving? this.secToMin(Number(Math.round(nextState[`minCursorValue`]+"e1")+"e-1")): "" } </div>
              <div id="min-thumb" style={minTransform} onMouseDown={(e)=>{this.handleMousedown(e, "min"); }} > </div>
              <div id="mid-shadow" style={midShadow}  onMouseDown={(e)=>{this.handleMousedown(e, "range")}}  > {nextState.isPlaying?<div id="play-thumb" style={{left: `${nextState[`playCursorX`]}px`}}> </div>: !(nextState.minisMoving || nextState.maxisMoving) ? this.secToMin(Number(Math.round(nextState[`maxCursorValue`]-nextState[`minCursorValue`]+"e1" )+"e-1" )): "" }</div>
              <div  id="max-thumb" style={maxTransform} onMouseDown={(e)=>{this.handleMousedown(e, "max");}} > </div>
              <div  id="max-shadow" style={maxshadowWidth}> {nextState.maxisMoving? this.secToMin(Number(Math.round(nextState[`maxCursorValue`]+"e1")+"e-1")): "" }</div>
          </React.Fragment>
      );
    }

    addEffects(){
        this.setState({
            effects : true
        })
    }


    handleinputChange(e,type){
        try {
		let tempState = {};
		this.sliderInputChange = true;
		let value = parseFloat(e.target.value);
		tempState[type] = value;
		if(type !== "intensity")
		{
			this.changeFilterValue(type, value);
			this.setState(tempState);
		}
		else{
			let hueValue = this.state.givenHue;
			this.handleSetFilters(this.state.editFilters,value, (this.state.givenBright*value)/50, (this.state.givenContrast*value)/50, (hueValue*value)/50, (this.state.givenSaturate*value)/50, this.state.tint, (this.state.givenBlur*value)/50, (this.state.givenVignette*value)/50)
        }
    }catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "BgVideoComponent-handleinputChange");
    }
    }
    
    changeFilterValue(type, value) {
		value = parseFloat(value);
		let opacity = this.props.tintOpacity, selectedId = "bgImg", selectedElem = document.getElementById("video-effects-block");
		let hueValue = this.state.hue;
		if(hueValue !== 0){
			hueValue *= 1.8; hueValue += 180;
		}
		if(!selectedElem) return;
		switch (type) {
			case 'bright':
				selectedElem.style.filter = "brightness(" + (value + 100) + "%) contrast(" + (this.state.contrast + 100) + "%) hue-rotate(" + hueValue + "deg) blur(" + this.state.blur + "px) saturate(" + (this.state.saturate + 100) + "%)";
				break;
			case 'contrast':
				selectedElem.style.filter = "brightness(" + (this.state.bright + 100) + "%) contrast(" + (value + 100) + "%) hue-rotate(" + hueValue + "deg) blur(" + this.state.blur + "px) saturate(" + (this.state.saturate + 100) + "%)";
				break;
			case 'hue':
				if(value !== 0){
					value *= 1.8;
					value += 180;
				}
				selectedElem.style.filter = "brightness(" + (this.state.bright + 100) + "%) contrast(" + (this.state.contrast + 100) + "%) hue-rotate(" + value + "deg) blur(" + this.state.blur + "px) saturate(" + (this.state.saturate + 100) + "%)";
				break;
			case 'saturate':
				selectedElem.style.filter = "brightness(" + (this.state.bright + 100) + "%) contrast(" + (this.state.contrast + 100) + "%) hue-rotate(" + hueValue + "deg) blur(" + this.state.blur + "px) saturate(" + (value + 100) + "%)";
				break;
			case 'tint':
				if(value !== -1)
					selectedElem.pseudoStyle(selectedElem,selectedId,"after","background", "hsla(" + value + "," + (this.state.saturate + 100) + "%,50%," + opacity + ")");
				else
					selectedElem.pseudoStyle(selectedElem,selectedId,"after","background", "none");
				break;
			case 'blur':
				selectedElem.style.filter = "brightness(" + (this.state.bright + 100) + "%) contrast(" + (this.state.contrast + 100) + "%) hue-rotate(" + hueValue + "deg) blur(" + value + "px) saturate(" + (this.state.saturate + 100) + "%)";
				break;
			case 'vignette':
				if(value > 0)
					document.getElementById('video_filter-' + this.props.selectedScene).style.backgroundImage = "radial-gradient(circle farthest-side at center center, rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, " + (value*0.007) + ") 130%)";
				else
					document.getElementById('video_filter-' + this.props.selectedScene).style.backgroundImage = "none";
				break;
			case 'opacity':
				selectedElem.style.opacity = value/100;
				
				if(value < this.props.tintOpacity)
				opacity = value;
				if(this.state.tint !== -1)
					selectedElem.pseudoStyle(selectedElem,selectedId,"after","background", "hsla(" + this.state.tint + "," + (this.state.saturate + 100) + "%,50%," + opacity + ")");
				else
					selectedElem.pseudoStyle(selectedElem,selectedId,"after","background", "none");
				break;
			default:
				break;
		}
	}
    convertToHex(d,type) {
		var slice = -2, append = "00";
		d = parseInt(d,10);
		if(type === 'hue' || type === 'tint')
		  slice = -3;
		if(d === -1)
		  append = " ";
		return  (append+(Number(d).toString(16))).slice(slice).toUpperCase()
    }
    handleCancelClick(position= null){
        try {
        if(position === 3){
            this.setState({
                filterEffects : false,
            });
        }
        if(position === 2){
            this.setState({
                filterEffects : false,
                effects:false
            });
        }
        if(position === 1){
            this.setState({
                filterEffects : false,
                effects:false
            });
        }
        if(position === '' || position === null){
            this.setState({
                filterEffects : false,
                effects : false
            });
         }
         if(position === 'cancel'){
            this.props.cancelPopup();
            
         }
        }catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "BgVideoComponent-handleCancelClick");
        }

    }

    handleSaveClick(){
    }
  
    handleplayheadClick(event){
     try {
        if(this.state.playVideo) return;
        this.setState({
            activeCursorOffsetClient: event.clientX - this.state.indicatorPos,
        },()=>{
            window.addEventListener('mousemove', this.handleplayheadMove, false);
        });
    }catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "BgVideoComponent-handleplayheadClick");
    }
    }

    handleplayheadMove(event){
        try {
        this.playheadMove = true;
        var totalWidth = document.getElementById('duration-in-width-video').offsetWidth + this.defaultThumbPosition;
        var leftEnd = this.defaultThumbPosition, rightEnd = totalWidth;
        let timeScale = totalWidth / this.state.videoDuration, translateValue = event.clientX - this.state.activeCursorOffsetClient;
        if(translateValue < leftEnd) translateValue = leftEnd;
        if(translateValue > rightEnd) translateValue = rightEnd;
        
        let cursorValue = parseFloat((Math.ceil((translateValue/timeScale)*20)/20).toFixed(2));
        translateValue = cursorValue * timeScale;
        document.getElementById('video-in-popup').currentTime =  cursorValue;
        this.setState({indicatorPos: translateValue});
        }catch (error) {
            //Error Severity: LOW
            errorlog(error, error.message, "BgVideoComponent-handleplayheadMove");
        }
    }
   generateThumbnails=()=>{
                let thumbDetails= {};
                thumbDetails.src=this.props.workspaceBG.get('thumbnail') ;
                thumbDetails.mainType= this.props.workspaceBG.get('type');
                thumbDetails.musicEnd= this.props.workspaceBG.get('videoEnd');
                thumbDetails.musicDuration= this.props.workspaceBG.get('videoDuration');
                
                let objWidth = document.querySelector(".second-video-range").offsetWidth;
            var setThumbNail = [];
    
            if(thumbDetails.src !== "" && (thumbDetails.mainType !== "UPLOADS" || thumbDetails.mainType !== "IMG" || thumbDetails.mainType !== "STOCKIMG" || thumbDetails.mainType !== "UPIMAGE" || thumbDetails.mainType !== "BG"))
            {
    
              var imageCount = Math.ceil(objWidth/90);
    
              var vidStyle = {}
              vidStyle.backgroundImage = "";
              vidStyle.backgroundPosition = "";
    
              var offset = 0
    
              var left = 0;
              var xPos = -90 + offset;
              for (var i = 0; i < imageCount; i++) {
                thumbDetails.musicDuration / 2
                var takenFrames = thumbDetails.musicDuration / 2;
                let divider = 1;
                var maxFrame = thumbDetails.musicEnd/divider;
                if (maxFrame > 150) maxFrame = 150;
                var frameCount = (imageCount / maxFrame)
                var currentFrame = Math.floor(i / frameCount)
                var videoThumburl =  this.assetUrl+"animaker/videothumbs/newimage.png"
                if (thumbDetails.mainType === "UPVIDEO"){
                    let thumbSrc;
                    thumbDetails.src=this.props.workspaceBG.get('src');
                    if(thumbDetails.src.includes('proxy1'))
                        thumbSrc = thumbDetails.src.replace('proxy1', 'thumbstrip');
                    else{
                        thumbSrc = thumbDetails.src.split('video/').join('video/thumbstrip/');
                    }
                    videoThumburl = config['UPLOADS'][config['UPLOADS']['workspace_UPVIDEO']]+ thumbSrc.split(".")[0] + ".png";
                    if(this.props.workspaceBG.get('isBlob')){
                        videoThumburl = this.props.workspaceBG.get('thumbnail')
                    }
                }
                else if(thumbDetails.mainType==="STOCKVID"){
                  videoThumburl = config['VIDEO']["thumbStrip"]+thumbDetails.src;
                }else if(thumbDetails.mainType === 'VIDEO' && this.props.workspaceBG.get('subType') === 'OBGVID'){
                    videoThumburl = this.assetUrl+config['BG']['obgsrc']+this.props.workspaceBG.get('thumbnail').split('thumb').join('thumbstrip');
                }
                xPos = xPos + 90;
                var yPos = currentFrame * 50 * -1
    
           
                  if (vidStyle.backgroundImage === ""){
                    
                    vidStyle.backgroundImage += "url(" + videoThumburl + ")"
                  }
                  else{
                    vidStyle.backgroundImage += ",url(" + videoThumburl + ")"
                  }
    
                    if (vidStyle.backgroundPosition === "")
                      vidStyle.backgroundPosition += xPos + "px " + yPos + "px";
                  else
                    vidStyle.backgroundPosition += "," + xPos + "px " + yPos + "px";
              }

              if(document.querySelector(".second-video-range"))
              {
                document.querySelector(".second-video-range").style.backgroundImage = vidStyle.backgroundImage
                document.querySelector(".second-video-range").style.backgroundPosition = vidStyle.backgroundPosition
              }
              
          }
      }    
    
getFlipPosition =()=>{
    let style= {};
   let flipPos = this.props.workspaceBG.get("flipPosition");
   style.transform =  (flipPos === 1)? " scaleX(-1)":(flipPos === 2)?" scaleY(-1)":(flipPos === 3)?" scaleX(-1) scaleY(-1)":"";
return style;
    }
    render(){
        this.OutPutData = [];
        var configBasePath = this.props.workspaceBG.get('src');
        var onLoadPath = this.props.workspaceBG.get('thumbnail');
        var bgType=this.props.workspaceBG.get('type');
        if(bgType !== "UPVIDEO" && bgType==="STOCKVID"){
            onLoadPath =  config[bgType][config[bgType].onload] + this.props.workspaceBG.get('thumbnail');
            configBasePath = config[bgType][config[bgType].workspace]+this.props.workspaceBG.get('src');
        }else if(bgType === "UPVIDEO"){
            let typrToSet = 'UPLOADS';
            onLoadPath = config[typrToSet][config[typrToSet].onload_UPVIDEO]+ this.props.workspaceBG.get('thumbnail');
            configBasePath = config[typrToSet][config[typrToSet].workspace_UPVIDEO]+this.props.workspaceBG.get('src');
            if(this.props.workspaceBG.get("isBlob")){
                onLoadPath =  this.props.workspaceBG.get('thumbnail');
                configBasePath = this.props.workspaceBG.get('src');
            }
        }else if(bgType === 'VIDEO' && this.props.workspaceBG.get('subType') === 'OBGVID'){
            onLoadPath =  this.assetUrl+config['BG']['obgsrc']+this.props.workspaceBG.get('thumbnail');
            configBasePath = this.assetUrl+config['BG']['obgsrc']+this.props.workspaceBG.get('src');
        }
        else{
            this.handleCancel();
        }

        var Duration        =   this.secondsToHms(this.props.sceneDuration);
        let chnageImage = 'scene_play';
        if(this.state.playVideo)
            chnageImage = 'scene_stop';
            
            let displayBlock = 'grid';
        if(this.state.effects)
             displayBlock = 'none';

             var audioIcon = 'audio';             
             if(this.state.muteValue || this.state.volume===0){
                 audioIcon = 'mute';
                }
                 
            
        return(
            <React.Fragment>
            <div className="loading-bar-popup" style={{display : this.loadedData ? 'none' : 'block'}}>
                <img id="loading-image-display" draggable="false" src={this.appUrl + "/images/loaders/round-load.gif"} alt="Loading..." />
            </div>
            <div className="main-common-popup tool-bar" style={this.container}>
                <div className="first-half" key="bg-video-popup">
                    <div className="first-half-top" style={this.getFlipPosition()}>
                        <div id="video-effects-block" style={{width: "100%",margin: '0 auto', textAlign: "center"}}>
                            {/* <div id={"video_filter-" + this.props.selectedScene} className="video_filter"></div> */}
                            <video id="video-in-popup" preload="auto" poster={onLoadPath} style={this.getWidthandHeight(this.props.bgVideoWidth, this.props.bgVideoHeight)} src={configBasePath}  type="video/mp4">
                            </video>
                        </div>
                        {/* <div className="play-all">
                            <img alt="scene_play" src={"/images/player-icons/"+chnageImage+".png"} style={{width: '30%', height: '85%'}} onClick={()=>{this.runVideo()}}/> 
                            <div className="scene-duration-popup">
                                <span>Scene 1</span>
                                <span>{Duration}</span>
                            </div>
                        </div> */}
                    </div>
                    
                    <div className="first-half-bottom">
                    <div   className="first-play-button"><img alt="scene_play" src={this.appUrl + "/images/video_cutter/"+chnageImage+".svg"}  onClick={()=>{this.runVideo()}}/> </div>
                    <div style={{display: 'flex', flex: '1 1'}} className="parentSecond-video-range">
                    <div className="second-video-range"> 

                    {/* <div className="middle-visdeo-range" id="duration-in-width-video">
                    </div> */}
                        {/* <div className="cut-start-time range-in-video">
                            <input  className="time-in-popup" type="number" value={this.state.inputStart} size="5" maxLength="3" onChange={(e)=>{this.onInputChange('start',e)}} onFocus = {() => this.props.setWorkspaceTextFocus(true)} onBlur={(e)=>{this.onInputChange('start',e,'blur')}}/>
                        </div>
                        <img src={this.appUrl + "/images/video_cutter/Current-indicator.svg"} alt="indicator" className="indicator" draggable="false" style={{transform: `translate3d(${this.state.indicatorPos}px,0,0)`}} onMouseDown={(e) => {this.handleplayheadClick(e)}} />
                        <div className="cut-end-time range-in-video">
                            <input className="time-in-popup" type="number" value={this.state.inputEnd} onChange={(e)=>{this.onInputChange('end',e)}} size="5" maxLength="3" onFocus = {() => this.props.setWorkspaceTextFocus(true)} onBlur={(e)=>{this.onInputChange('end',e,'blur')}}/> 
                        </div> */}
                        {this.thumbs}
                    </div>
                    </div>
                    <div className="third-section">
                    <div className="third-sound-button volume_holder" key="volume-ui">
                        <div id="bg-videoSlider">  <input className="bg-videoSlider-input" type="range" value={this.state.volume}  onChange={this.applyVolume} onMouseUp={this.saveVolume}   style={{ background: `linear-gradient(to right, #f3c340 0%, #f3c340 ${this.state.volume}%, rgb(239, 242, 244) ${this.state.volume}%, rgb(239, 242, 244,0.9) 100%)` }}  min="0" step = "10" max="100"  /> </div>
                        <img alt="scene_play" src={this.appUrl + "/images/video_cutter/"+audioIcon+".svg"}  onClick={(event)=>{this.enableMute(event)}}/> 
                    </div>
                    <div className="third-sound-button last_image tick-bg"><img alt="scene_play" src={this.appUrl + "/images/video_cutter/tick_mark.svg"}  onClick={()=>{this.applyVideoChanges()}}/> </div>
                    </div>
                </div>
                </div>
            </div>
            </React.Fragment>
        )};

}

export default BgVideoComponent;


// WEBPACK FOOTER //
// ./src/components/BgVideoComponent.js